export const LABEL = {
  login: {},
};

export const SESSION_DURATION = 180000;
